import { NgService } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { AuthService } from "@app/services/auth.service";
import { IRootScope } from "@models";
import { Transition, TransitionService } from "@uirouter/angularjs";
import { ILocationService } from "angular";


@NgService({
    token: Token.TelemetryService,
    dependencies: [
        Token.$RootScope,
        Token.$Transitions,
        Token.$Location,
        Token.AuthService
    ]
})
export class TelemetryService {
    constructor(
        private $rootScope: IRootScope,
        private $transitions: TransitionService,
        private $location: ILocationService,
        private authService: AuthService
    ) {
        authService.contextPromise.then(() => {
            if ($rootScope.context.appInsightsKey) {
                var snippet = {
                    config: {
                        instrumentationKey: $rootScope.context.appInsightsKey,
                        disableAjaxTracking: true
                    } as Microsoft.ApplicationInsights.IConfig
                } as Microsoft.ApplicationInsights.IConfig;
                var init = new Microsoft.ApplicationInsights["Initialization"](snippet);
                this._appInsights = init.loadAppInsights() as Microsoft.ApplicationInsights.IAppInsights;

                $transitions.onSuccess({}, (transition: Transition) => {
                    let state = transition.to();
                    if (state && state.name && state.url && state.name != this.lastState && state.name != "kb.admin") {
                        let name = this.lastState = state.name;
                        if (name.startsWith("kb.")) name = name.slice(3);
                        name = name.replace(".base.", ".");
                        // name = name.replace(".", "/");
                        // name = "/" + name;
                        let url = [$location.protocol(), '://', $location.host(), $location.path()].join(''); //url with no query string
                        this.trackPageView(name, url);
                    }
                });
            }
        });
    }

    private lastState: string;
    private _appInsights: Microsoft.ApplicationInsights.IAppInsights;

    private setDefaultProperties(properties: any = null) {
        properties = properties || {};
        if (this.$rootScope.company && this.$rootScope.company.subdomain) {
            properties.Company = this.$rootScope.company.subdomain;
        }
        properties.App = "Client";
        return properties;
    }

    public trackPageView(name?: string, url?: string, properties?: any) {
        if (this._appInsights) {
            this._appInsights.trackPageView(name, url, this.setDefaultProperties(properties))
        }
    }

    public trackEvent(name?: string, properties?: any) {
        if (this._appInsights) {
            this._appInsights.trackEvent(name, this.setDefaultProperties(properties));
        }
    }

    public trackException(exception: Error) {
        if (this._appInsights) {
            this._appInsights.trackException(exception, null, this.setDefaultProperties());
        }
    }
}
